module.exports = __webpack_public_path__ + "img/discount-panel.8a2324c8.png";